







































































































import _ from "lodash";
import { createComponent, computed, ref } from "@vue/composition-api";
import { SummaryMethodParams } from "element-ui/types/table";
import { VueConstructor } from "vue";
import { InputValidationError } from "@/shared/validators";
import { TableColumnConfig, TableConfig } from "./BaseTable.vue";

interface Props {
  value: any[];
  columns: TableConfig;
  editable: boolean;
  showSummary: boolean;
  unitFormComponent: VueConstructor;
  addItem: (item: any) => void | Promise<void>;
  removeItem: (item: any) => void;
  updateItem: (original: any, updated: any) => void;
  createEditItem: (original: any) => any;
  createNewItem: () => any;
}

export default createComponent<Props>({
  components: {},
  props: {
    value: { required: true, type: Array },
    columns: { required: true, type: Object },
    editable: { default: false, type: Boolean },
    showSummary: { default: false, type: Boolean },
    unitFormComponent: { required: false },
    addItem: { required: false, type: Function },
    removeItem: { required: false, type: Function },
    updateItem: { required: false, type: Function },
    createEditItem: { type: Function, default: _.cloneDeep },
    createNewItem: { type: Function, default: () => ({}) },
  },
  setup(props, ctx) {
    function getCellContent(
      fieldName: string,
      column: TableColumnConfig,
      row: any,
    ) {
      const fieldValue = _.get(row, fieldName);
      return column.formatter ? column.formatter(fieldValue) : fieldValue;
    }

    const getSummaries = ({ columns, data }: SummaryMethodParams) => {
      return columns.map((col: any) => {
        const summaryGetter =
          props.columns[col.property] && props.columns[col.property].getSummary;
        if (summaryGetter) return summaryGetter();
        return undefined;
      });
    };
    const newItem = ref<any>(null);
    const newItemErrors = ref<any>(undefined);
    const editItemOriginal = ref<any>(null);
    const editItem = ref<any>(null);
    const editItemErrors = ref<any>(undefined);

    function openNewItemDialog() {
      newItem.value = props.createNewItem();
    }
    async function commitNewItem() {
      newItemErrors.value = undefined;
      try {
        await props.addItem(newItem.value);
        newItem.value = null;
      } catch (e) {
        if (e instanceof InputValidationError) newItemErrors.value = e.fields;
        throw e;
      }
    }

    function startEditingItem(item: any) {
      if (!props.editable) return;
      editItemOriginal.value = item;
      editItem.value = props.createEditItem(item);
    }
    async function commitEditItem() {
      editItemErrors.value = undefined;
      try {
        await props.updateItem(editItemOriginal.value, editItem.value);
        editItem.value = null;
      } catch (e) {
        if (e instanceof InputValidationError) editItemErrors.value = e.fields;
        throw e;
      }
    }

    async function removeEditItem() {
      await props.removeItem(editItem.value);
      editItem.value = null;
    }

    const classes = computed(() => {
      let result = "base-table";
      if (props.editable) result += " editable";
      return result;
    });

    return {
      removeEditItem,
      classes,
      commitEditItem,
      commitNewItem,
      editItem,
      editItemErrors,
      editItemOriginal,
      getCellContent,
      getSummaries,
      newItem,
      newItemErrors,
      openNewItemDialog,
      startEditingItem,
    };
  },
});
